import { ReleaseAndDeployments } from '@agilelab/plugin-wb-builder-common';
import {
  createActionsColumn,
  TableCellProps,
} from '@agilelab/plugin-wb-platform';
import {
  ReleaseActions,
  ReleaseCreatedBy,
  ReleaseDeploymentStatus,
  ReleaseName,
  ReleaseUpdate,
} from '../ReleaseTableColumns';

export function useReleasesTableColumns(): TableCellProps<ReleaseAndDeployments>[] {
  return [
    {
      field: 'release' as keyof ReleaseAndDeployments,
      fieldRender: field => <ReleaseName release={field} />,
      headerName: 'Release',
      sortable: true,
    },
    {
      field: 'update' as keyof ReleaseAndDeployments,
      fieldRender: field => <ReleaseUpdate release={field} />,
      headerName: 'Update',
      sortable: true,
    },
    {
      field: 'createdBy' as keyof ReleaseAndDeployments,
      fieldRender: field => <ReleaseCreatedBy release={field} />,
      headerName: 'Created By',
      sortable: true,
    },
    {
      field: 'deploymentStatus' as keyof ReleaseAndDeployments,
      fieldRender: field => <ReleaseDeploymentStatus release={field} />,
      headerName: 'Deployment Status',
      sortable: false,
    },
    createActionsColumn({
      width: 280,
      renderActions: field => <ReleaseActions release={field} />,
    }),
  ];
}
